import { NumberInput as MantineNumberInput } from '@mantine/core';

export const NumberInput = MantineNumberInput.extend({
	defaultProps: {
		hideControls: true,
		allowNegative: false,
		decimalScale: 2,
	},
});
